const HOST = process.env.REACT_APP_ZINIO_READER_URL;
const USER_ID = process.env.REACT_APP_ZINIO_USER_ID;
const IFRAME_ID = 'hcn-zinio-reader';
const URL_PARAMS_KEY = {
    ZINIO_ACCESS_TOKEN: 'access_token'
};

const rootElement = document.getElementById('root');

function parseUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const zinioAccessToken = params.get(URL_PARAMS_KEY.ZINIO_ACCESS_TOKEN);
    return { zinioAccessToken };
}

function zinioReaderUrl() {
    return (HOST || '') + window.location.hash;
}

function zinioIframeInit(token) {
    const src = zinioReaderUrl();
    const iframe = document.createElement('iframe');
    iframe.setAttribute('id', IFRAME_ID);
    iframe.setAttribute('src', src);
    iframe.setAttribute('allow', 'fullscreen');
    iframe.setAttribute('frameborder', '0');
    iframe.onload = function () {
        iframe.contentWindow?.postMessage({
            ACCESS_TOKEN: token,
            USER_ID: USER_ID,
        }, HOST);
    };
    iframe.onerror = function (e) {
        console.log("[iframe.onerror] error", e);
    };
    return iframe;
}

function init() {
    if (rootElement) {
        const { zinioAccessToken } = parseUrlParams();
        const iframe = zinioIframeInit(zinioAccessToken || '');

        window.onmessage = function ( e ) {
            if (typeof e.data === 'string') {
                window.history.pushState(null, "", e.data);
            }
        };

        rootElement.appendChild(iframe);
    }
};

init();
